import React from 'react';
import './Pagination.css';

const normalizeCount = (value) => (
  Number.isFinite(value) && value > 0 ? Math.floor(value) : 0
);

const getPageItems = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 4) {
    return [1, 2, 3, 4, 5, 'end-ellipsis', totalPages];
  }

  if (currentPage >= totalPages - 3) {
    return [1, 'start-ellipsis', ...Array.from({ length: 5 }, (_, index) => totalPages - 4 + index)];
  }

  return [
    1,
    'start-ellipsis',
    currentPage - 1,
    currentPage,
    currentPage + 1,
    'end-ellipsis',
    totalPages,
  ];
};

const Pagination = ({ page, totalPages, totalItems, onPageChange }) => {
  const normalizedTotalPages = normalizeCount(totalPages);
  const requestedPage = normalizeCount(page) || 1;
  const currentPage = normalizedTotalPages === 0
    ? 0
    : Math.min(requestedPage, normalizedTotalPages);
  const normalizedTotalItems = normalizeCount(totalItems);
  const pageItems = getPageItems(currentPage, normalizedTotalPages);

  const changePage = (nextPage) => {
    if (
      typeof onPageChange === 'function'
      && nextPage >= 1
      && nextPage <= normalizedTotalPages
    ) {
      onPageChange(nextPage);
    }
  };

  return (
    <div className="pagination">
      <span className="pagination__total">총 {normalizedTotalItems}건</span>
      <nav className="pagination__controls" aria-label="페이지 탐색">
        <button
          type="button"
          className="pagination__button pagination__button--direction"
          aria-label="이전 페이지"
          disabled={currentPage <= 1}
          onClick={() => changePage(currentPage - 1)}
        >
          이전
        </button>

        {pageItems.map((item) => (
          typeof item === 'number' ? (
            <button
              type="button"
              className={`pagination__button${item === currentPage ? ' pagination__button--current' : ''}`}
              aria-label={item === currentPage ? `${item}페이지, 현재 페이지` : `${item}페이지로 이동`}
              aria-current={item === currentPage ? 'page' : undefined}
              key={item}
              onClick={() => changePage(item)}
            >
              {item}
            </button>
          ) : (
            <span className="pagination__ellipsis" aria-hidden="true" key={item}>…</span>
          )
        ))}

        <button
          type="button"
          className="pagination__button pagination__button--direction"
          aria-label="다음 페이지"
          disabled={currentPage === 0 || currentPage >= normalizedTotalPages}
          onClick={() => changePage(currentPage + 1)}
        >
          다음
        </button>
      </nav>
    </div>
  );
};

export default Pagination;